module.exports = __webpack_public_path__ + "media/images/tibiacoins_logo-4aa1dc587a5d96a20b75e6b3b6282c69.png";